module.exports = __webpack_public_path__ + "media/tower-dropper-gameplay.e41ef376.mp4";